/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Skew window (ms) applied when checking token expiry. A token whose
 * expiration falls within this window from now is treated as expired so the
 * refresh happens before a request can go out with a token the service is
 * about to reject.
 *
 * This is the single definition. `viewModel/signIn/signIn.constants.ts`
 * re-exports it so the view-model keeps its own import path.
 */
export const TOKEN_EXPIRY_SKEW_MS: number = 5 * 60 * 1000;

/**
 * Context key for the account-level token — the token minted for the
 * subscriber account rather than for one profile under it.
 *
 * Kept as the literal `"account"` because it is already the on-disk key
 * suffix written by earlier builds; changing it would orphan every persisted
 * account token in the field.
 */
export const ACCOUNT_CONTEXT_ID: string = "account";
